var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.59164C1.06572 3.26551 1.26234 2.43869 1.85051 1.85051C2.43869 1.26234 3.26551 1.06572 4.59164 1M13 4.59164C12.9343 3.26551 12.7376 2.43869 12.1495 1.85051C11.5613 1.26234 10.7345 1.06572 9.40834 1M9.40834 13C10.7345 12.9343 11.5613 12.7376 12.1495 12.1495C12.7376 11.5613 12.9343 10.7345 13 9.40834M4.59164 13C3.26551 12.9343 2.43869 12.7376 1.85051 12.1495C1.26234 11.5613 1.06572 10.7345 1 9.40834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57898 7H11.4211",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan_icon.43b5e3f1ceee64d596b46304fc2218e2.svg";
export { ForwardRef as ReactComponent };